import { get, post } from "./base";

const DeliveryStaffFeeServ = {
    index: () => get("/delivery-staff-fee"),
    create: (payload) => post("/delivery-staff-fee", payload),
};

export default DeliveryStaffFeeServ;
